export default "__VITE_ASSET__7OSSBI1J__"